<template>
  <div :class="mode === 'add-licenses' ? 'white-background' : 'loginimg'">
    <!-- Only show logo for registration mode -->

    <CustomerLogo v-if="mode === 'registration'" />

    <div class="row justify-content-center">
      <div :class="mode === 'add-licenses' ? 'mt-6' : 'mt-10'" class="col-10 col-md-6 col-lg-5 col-xl-4 align-self-center justify-content-center row">

        <!-- Warning Icon -->
        <div class="col-12 text-center mb-6">
          <v-icon color="orange" size="80">
            mdi-alert
          </v-icon>
        </div>

        <!-- Title -->
        <div :class="mode === 'add-licenses' ? 'black--text' : 'white--text'" class="col-12 text-h4 text-center">
          {{ $t('checkout_cancelled') }}
        </div>

        <!-- Message -->
        <div :class="mode === 'add-licenses' ? 'black--text' : 'white--text'" class="col-10 text-center mb-8 mt-4" style="opacity: 0.85; font-size: 14px;">
          {{ $t('checkout_cancelled_message') }}
        </div>

        <!-- Try Again Button -->
        <div class="pa-0 col-10 mb-4">
          <v-btn
            class="w-100 white--text signinbtn"
            style="padding: 27px !important; background-color: #161616 !important;"
            outlined
            tile
            @click="tryAgain">
            {{ $t('try_again') }}
          </v-btn>
        </div>

        <!-- Skip/Back Button -->
        <div class="pa-0 col-10 mb-8 text-center">
          <v-btn
            text
            :class="mode === 'add-licenses' ? 'black--text' : 'white--text'"
            style="text-transform: none; font-size: 14px; text-decoration: underline;"
            @click="goBack">
            {{ mode === 'registration' ? $t('skip_for_now') : $t('back_to_licenses') }}
          </v-btn>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import CustomerLogo from "@/components/custom/CustomerLogo.vue";

export default {
  name: 'SubscriptionCancelled',
  components: {CustomerLogo},

  computed: {
    mode() {
      return this.$route.query.mode || 'registration';
    }
  },

  methods: {
    tryAgain() {
      this.$router.push({
        path: '/subscription-plans',
        query: { mode: this.mode }
      });
    },

    goBack() {
      if (this.mode === 'registration') {
        // Skip to login for new registrations
        this.$router.push('/login');
      } else {
        // Go back to licenses page
        this.$router.push('/licenses');
      }
    }
  }
};
</script>

<style scoped>
.white-background {
  background-color: white;
  min-height: 100vh;
  padding: 20px 0;
}
</style>
